import { React, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Input, Switch, Flex, Steps, ConfigProvider, Tooltip } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import colors from "../../../../../styles/_colors.scss";
import { useDirtyState } from "../../../../../hooks/useDirtyState";
import { SupportRequestLink } from "../../../../elements/SupportRequestLink";

const { Step } = Steps;

export const TeamsNotifModal = ({ context }) => {
  const {
    teamsNotifImplementationLink,
    enableTeamsNotif,
    teamsChannel,
    teamsWebhook,
    setConfigParams,
    setModalSaveStatus = () => {},
  } = useContext(context);

  const [notifStatus, setNotifStatus] = useState(enableTeamsNotif);
  const [channel, setChannel] = useState(teamsChannel);
  const [webhook, setWebhook] = useState(teamsWebhook);
  const [configParamsToSave, setConfigParamsToSave] = useState({});
  const [current, setCurrent] = useState(0);

  const [showGuideDiv, setShowGuideDiv] = useState(false);

  // Reset local state when props change (when modal reopens with new data)
  useEffect(() => {
    setNotifStatus(enableTeamsNotif);
    setChannel(teamsChannel);
    setWebhook(teamsWebhook);
  }, [enableTeamsNotif, teamsChannel, teamsWebhook]);

  const handleNotifStatusChange = () => setNotifStatus(!notifStatus);

  const handleChannelChange = (event) => setChannel(event.target.value);

  const handleWebhookChange = (event) => setWebhook(event.target.value);

  useEffect(() => {
    const newObject = { ...configParamsToSave };
    newObject.teams_updates = notifStatus;
    newObject.teams_channel = channel;
    newObject.teams_webhook = webhook;
    setConfigParamsToSave(newObject);
  }, [notifStatus, channel, webhook]);

  useDirtyState(
    { notif: enableTeamsNotif, channel: teamsChannel, webhook: teamsWebhook },
    { notif: notifStatus, channel, webhook },
    setModalSaveStatus,
  );

  useEffect(() => setConfigParams(configParamsToSave), [configParamsToSave]);

  useEffect(() => {
    if (notifStatus) {
      setCurrent(1);
    } else {
      setCurrent(0);
    }
  }, [notifStatus]);

  return (
    <div className="modal-elems-rows">
      <div>
        <h2 className="header-letter-spacing">Teams notifications</h2>
      </div>
      <div className="container-guide modal-panel-button-row">
        <Link
          className="modal-guide-banner "
          target="_blank"
          to={teamsNotifImplementationLink}
        >
          <div className="file-icon">
            <svg
              width="30"
              height="36"
              viewBox="0 0 30 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_190_157)">
                <path
                  d="M2.64922 3.41406H16.4948V7.60147C16.4948 7.95999 16.7855 8.25062 17.144 8.25062H19.3979V26.6164C19.3979 26.975 19.1073 27.2656 18.7488 27.2656H2.64922C2.2907 27.2656 2.00006 26.975 2.00006 26.6164V4.06322C2.00006 3.7047 2.2907 3.41406 2.64922 3.41406Z"
                  fill="#69C4FF"
                  fillOpacity="0.5"
                />
                <path
                  d="M3.72516 24.6433H16.4543C16.4543 24.8469 16.6193 25.0119 16.8228 25.0119H19.4347V25.8118C19.4347 26.1703 19.1441 26.4609 18.7856 26.4609H4.37431C4.0158 26.4609 3.72516 26.1703 3.72516 25.8118V24.6433Z"
                  fill="#69C4FF"
                  fillOpacity="0.5"
                />
                <path
                  d="M4.34194 1.79309H18.3155V5.98808C18.3155 6.3466 18.6061 6.63724 18.9646 6.63724H21.7393V25.0329C21.7393 25.3914 21.4487 25.682 21.0902 25.682H4.34194C3.98342 25.682 3.69278 25.3914 3.69278 25.0329V2.44225C3.69278 2.08373 3.98342 1.79309 4.34194 1.79309Z"
                  fill="#DBF1FF"
                />
                <path
                  d="M5.41306 22.566H18.6682C18.6682 22.755 18.8214 22.9082 19.0104 22.9082H21.7718V23.6046C21.7718 23.9631 21.4811 24.2538 21.1226 24.2538H6.06221C5.70369 24.2538 5.41306 23.9631 5.41306 23.6046V22.566Z"
                  fill="#B0E0FF"
                />
                <path
                  d="M6.06221 0.170166H18.7207V4.25985C18.7207 4.61837 19.0114 4.909 19.3699 4.909H23.46V22.6673C23.46 23.1492 23.0694 23.5398 22.5875 23.5398H6.06221C5.70369 23.5398 5.41306 23.2491 5.41306 22.8906V0.819322C5.41306 0.460803 5.70369 0.170166 6.06221 0.170166Z"
                  fill="white"
                />
                <line
                  x1="8.82252"
                  y1="9.40248"
                  x2="19.988"
                  y2="9.40248"
                  stroke="#009BFF"
                  strokeOpacity="0.14"
                  strokeWidth="0.389493"
                  strokeLinecap="round"
                />
                <line
                  x1="8.90306"
                  y1="15.1451"
                  x2="20.0685"
                  y2="15.1451"
                  stroke="#009BFF"
                  strokeOpacity="0.14"
                  strokeWidth="0.389493"
                  strokeLinecap="round"
                />
                <line
                  x1="8.82252"
                  y1="11.3499"
                  x2="19.988"
                  y2="11.3499"
                  stroke="#009BFF"
                  strokeOpacity="0.14"
                  strokeWidth="0.389493"
                  strokeLinecap="round"
                />
                <line
                  x1="8.90306"
                  y1="17.0925"
                  x2="20.0685"
                  y2="17.0925"
                  stroke="#009BFF"
                  strokeOpacity="0.14"
                  strokeWidth="0.389493"
                  strokeLinecap="round"
                />
                <line
                  x1="8.82252"
                  y1="13.1675"
                  x2="19.988"
                  y2="13.1675"
                  stroke="#009BFF"
                  strokeOpacity="0.14"
                  strokeWidth="0.389493"
                  strokeLinecap="round"
                />
                <path
                  d="M19.3703 4.946C19.0118 4.94601 18.7212 4.65537 18.7212 4.29685L18.7212 0.170195L23.4599 4.94597L19.3703 4.946Z"
                  fill="#69C4FF"
                  fillOpacity="0.14"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_190_157"
                  x="0.255097"
                  y="0.170166"
                  width="24.9498"
                  height="30.5854"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="1.74496" />
                  <feGaussianBlur stdDeviation="0.872482" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.168627 0 0 0 0 0.168627 0 0 0 0 0.709804 0 0 0 0.15 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_190_157"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_190_157"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          <div className="panel-button-text">
            <div className="panel-button-desc">
              Click here to follow the complete setup guide for the Teams
              notifications.
              <br /> Question not covered?{" "}
              <SupportRequestLink />
            </div>
          </div>
        </Link>
      </div>

      {/* <div className="">
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris.
        </p>
      </div> */}

      <ConfigProvider
        theme={{
          components: {
            Steps: {
              colorPrimary: colors.ccDarkBlue,
              processIconColor: colors.ccDarkBlue,
              customIconTop: "50%",
              customIconTransform: "translateY(-50%)",
              finishIconBorderColor: colors.ccDarkBlue,
              colorTextDescription: "rgba(0, 0, 0, 0.88)",
              waitIconColor: "rgba(0, 0, 0, 0.25)",
              waitDotColor: "rgba(0, 0, 0, 0.25)",
            },
          },
        }}
      >
        <Steps
          current={current}
          direction="vertical"
          className="centered-step-icons"
        >
          <Step
            description={
              <div className="step-with-form step-title">
                <span>Enable Teams notifications</span>
                <Switch
                  checked={notifStatus}
                  onChange={handleNotifStatusChange}
                />
              </div>
            }
          />

          {notifStatus && (
            <Step
              description={
                <div
                  style={{
                    border: "1px solid #DBF1FF",
                    borderRadius: "8px",
                    padding: "20px",
                  }}
                >
                  <div style={{ position: "relative" }}>
                    <h3 className="modal-category mb-0">
                      Account details
                      <Tooltip title="Check out our easy-to-follow guides at the top of the page to ensure successful configuration and setup of Teams notifications">
                        <InfoCircleFilled
                          className="info-icon"
                          style={{ marginLeft: "10px" }}
                        />
                      </Tooltip>
                    </h3>
                    <p>Add the incoming webhook of your Teams channel below.</p>
                    <Input
                      className="wide-input"
                      type="text"
                      placeholder="https://xxxxx.webhook.office.com/xxxxxxxxx"
                      defaultValue={webhook}
                      onChange={handleWebhookChange}
                    />
                  </div>

                  <div>
                    <p className="mb-2">
                      Add the name of the Teams channel where you would like to
                      receive your notifications.
                    </p>
                    <Input
                      className="wide-input"
                      type="text"
                      placeholder="code-cube-alerts"
                      defaultValue={channel}
                      onChange={handleChannelChange}
                    />
                  </div>
                </div>
              }
              status={webhook && channel ? "finish" : "process"}
            />
          )}
        </Steps>
      </ConfigProvider>
    </div>
  );
};
